export interface Song {
  id: string
  title: string
  duration: string
  spotifyUrl?: string
  appleMusicUrl?: string
}

export interface Release {
  // If `name` is set, this group renders with a slightly bolder header
  name?: string
  songs: Song[]
}

export interface YearGroup {
  year: string
  releases: Release[]
}

export const CATALOG: YearGroup[] = [
  {
    year: '2026',
    releases: [
      {
        songs: [
          { id: '26', title: 'sex...', duration: '2:11' },
          { id: '25', title: 'lightspeed!', duration: '2:16' },
          { id: '0', title: 'seance', duration: '3:13' },
          {
            id: '1',
            title: 'show pony',
            duration: '2:38',
            spotifyUrl:
              'https://open.spotify.com/track/5PtBrwL6W6vszW1tZrLuOL?si=99624c0f37254039',
            appleMusicUrl:
              'https://music.apple.com/us/album/show-pony/1895298811?i=6763404067',
          },
          { id: '2', title: 'overdrive', duration: '2:49' },
          { id: '3', title: 'matrix', duration: '3:10' },
          { id: '4', title: 'rematch', duration: '2:39' },
          { id: '5', title: 'spinning', duration: '2:09' },
        ],
      },
    ],
  },
  {
    year: '2025',
    releases: [
      {
        songs: [
          { id: '6', title: 'scumf*ck!', duration: '2:55' },
          { id: '7', title: 'i like it', duration: '4:34' },
          { id: '8', title: 'kids with drugs', duration: '2:09' },
          { id: '9', title: 'deadbeat', duration: '3:12' },
        ],
      },
      {
        name: 'you only live forever ep',
        songs: [
          { id: '10', title: 'fever', duration: '2:33' },
          { id: '11', title: 'manson', duration: '3:23' },
          { id: '12', title: "noah's ark", duration: '3:08' },
          { id: '13', title: 'one life', duration: '2:44' },
          { id: '14', title: 'messi', duration: '2:51' },
        ],
      },
      {
        name: 'b side',
        songs: [
          { id: '15', title: 'passport', duration: '2:13' },
          { id: '16', title: 'scratch offs', duration: '2:32' },
        ],
      },
    ],
  },
  {
    year: '2024',
    releases: [
      {
        songs: [
          { id: '17', title: 'good times', duration: '2:22' },
          { id: '18', title: 'plastic', duration: '3:28' },
          { id: '19', title: 'seaside', duration: '2:36' },
          { id: '20', title: '2:23 am', duration: '2:14' },
          { id: '21', title: 'hollow tips', duration: '3:01' },
          { id: '22', title: 'manson', duration: '3:23' },
          { id: '23', title: 'upstate', duration: '2:56' },
        ],
      },
    ],
  },
  {
    year: '2023',
    releases: [
      {
        songs: [{ id: '24', title: 'deja vu', duration: '3:31' }],
      },
    ],
  },
]
